import React from 'react'
import { IntlProvider, addLocaleData } from 'react-intl'
import { i18nDictionaries } from './i18nHelper'
import { LocalStorage } from '../localstorage'
import { I18n } from '../../models/i18n'

import de from 'react-intl/locale-data/de'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import fr from 'react-intl/locale-data/fr'
import it from 'react-intl/locale-data/it'
import ja from 'react-intl/locale-data/ja'
import pt from 'react-intl/locale-data/pt'
import tr from 'react-intl/locale-data/tr'
import zh from 'react-intl/locale-data/zh'
import th from 'react-intl/locale-data/th'

addLocaleData([
    ...de,
    ...en,
    ...es,
    ...fr,
    ...it,
    ...ja,
    ...pt,
    ...tr,
    ...zh,
    ...th,
])

const Context = React.createContext<any>({
    switchLanguage: (locale: string) => {},
    locale: 'en-US',
})

class IntlProviderWrapper extends React.Component<any, any> {
    switchLanguage: any

    constructor(props: any) {
        super(props)

        this.switchLanguage = (locale: string) => {
            let i18n: I18n = LocalStorage._shared().getI18n() || new I18n()
            i18n.locale = locale
            let messages = i18nDictionaries[locale]

            LocalStorage._shared().setI18n({ ...i18n })
            this.setState({ locale: i18n.locale, messages: messages })
        }

        let i18n: I18n = LocalStorage._shared().getI18n() || new I18n()
        let messages = i18nDictionaries[i18n.locale]

        // pass everything in state to avoid creating object inside render method (like explained in the documentation)
        this.state = {
            locale: i18n.locale,
            messages: messages,
            switchLanguage: this.switchLanguage,
            textComponent: React.Fragment,
        }
    }

    render() {
        const { children } = this.props
        return (
            <Context.Provider value={this.state}>
                <IntlProvider
                    locale={this.state.locale?.split('-')[0]}
                    messages={this.state.messages}
                    textComponent={React.Fragment}>
                    {children}
                </IntlProvider>
            </Context.Provider>
        )
    }
}

export { IntlProviderWrapper, Context as IntlContext }
